/**
 * Assign Agent Modal Component
 */
import { X, UserPlus } from "lucide-react";

export const AssignAgentModal = ({
  show,
  onClose,
  agents,
  selectedAgentId,
  setSelectedAgentId,
  onAssign,
  assigning
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-xl w-full max-w-md p-6 animate-fadeIn">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <UserPlus size={20} className="text-[#1B3F8F]" />
            <h3 className="text-lg font-semibold text-gray-900">Dodijeli agentu</h3>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X size={20} className="text-gray-500" />
          </button>
        </div>
        
        <select
          value={selectedAgentId}
          onChange={(e) => setSelectedAgentId(e.target.value)}
          className="w-full p-3 border border-gray-200 rounded-xl mb-4 focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
        >
          <option value="">Odaberi agenta...</option>
          {agents.map((agent) => (
            <option key={agent.id} value={agent.id}>
              {agent.name} ({agent.email})
            </option>
          ))}
        </select>
        
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 border border-gray-200 rounded-xl text-gray-700 font-medium hover:bg-gray-50"
          >
            Odustani
          </button>
          <button
            onClick={onAssign}
            disabled={assigning || !selectedAgentId}
            className="flex-1 py-3 px-4 bg-[#1B3F8F] text-white rounded-xl font-medium hover:bg-[#15327a] disabled:opacity-50"
          >
            {assigning ? "Dodjeljujem..." : "Dodijeli"}
          </button>
        </div>
      </div>
    </div>
  );
};
